const KEY = "qava_recent";

export function getRecent() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
}

export function pushRecent(product) {
  if (!product) return;
  const slim = {
    id: product.id, slug: product.slug, title: product.title, images: product.images,
    selling_price: product.selling_price, compare_at_price: product.compare_at_price,
    rating: product.rating, review_count: product.review_count, sold_count: product.sold_count,
    brand: product.brand, free_shipping: product.free_shipping, on_sale: product.on_sale,
    stock: product.stock, status: product.status, variants: product.variants || [],
  };
  let list = getRecent().filter((p) => p.id !== slim.id);
  list.unshift(slim);
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
}
